import {SOCKET_EVENT} from '@/constants/socket';
import socketMixin from '@/mixins/socket';

export default {
  mixins: [
    socketMixin,
  ],
  data() {
    return {
      socketListeners: [
        {
          event: SOCKET_EVENT.OD_BOOKING_ACCEPT,
          callback: this.onODBookingAccept,
        },
        {
          event: SOCKET_EVENT.OD_BOOKING_FORAPPROVAL,
          callback: this.onODBookingAccept,
        },
        {
          event: SOCKET_EVENT.OD_BOOKING_REJECT,
          callback: this.onODBookingReject,
        },
        {
          event: SOCKET_EVENT.OD_BOOKING_PAYMENTEXPIRE,
          callback: this.onODBookingReject,
        },
      ],
    }
  },
}
